import { Outlet } from 'react-router-dom';
import { useAuth } from '../lib/auth.js';
import s from './AppShell.module.scss';
import { LegalFooter } from './LegalFooter.js';
import { Sidebar } from './Sidebar.js';
import { TopBar } from './TopBar.js';

export function AppShell() {
  const { admin } = useAuth();
  if (!admin) return null;

  return (
    <div className={s.shell}>
      <Sidebar role={admin.role} isOwner={admin.is_owner} />
      <div className={s.content}>
        <TopBar />
        <main className={s.main}>
          <Outlet />
        </main>
        <LegalFooter />
      </div>
    </div>
  );
}
